/**
 * Format a date range for display
 * Handles both single-day and multi-day date ranges
 */
export const formatDateRange = (startDate: string | null, endDate: string | null): string => {
    if (!startDate || !endDate) return 'Dates TBA';

    const start = new Date(startDate);
    const end = new Date(endDate);

    // Using custom format for DD MMM, YYYY
    const formatDate = (date: Date) => {
        const day = date.getDate();
        const month = date.toLocaleDateString('en', { month: 'short' });
        const year = date.getFullYear();
        return { day, month, year };
    };

    if (startDate === endDate) {
        const { day, month, year } = formatDate(start);
        return `${day} ${month}, ${year}`;
    }

    const startFormatted = formatDate(start);
    const endFormatted = formatDate(end);
    return `${startFormatted.day} ${startFormatted.month}, ${startFormatted.year} - ${endFormatted.day} ${endFormatted.month}, ${endFormatted.year}`;
};
